import type { SxProps, Theme } from '@mui/material'

export const styles: Record<string, SxProps<Theme>> = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    p: 3,
  },
  panel: {
    maxWidth: 420,
    width: '100%',
  },
  form: {
    width: '100%',
  },
}
